function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 758,
    height: 764,
    viewBox: "0 0 758 764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.9,
    y: 117.9,
    width: 407,
    height: 493,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364,36h0c201,0,364,163,364,364h0c0,201-163,364-364,364h0C163,764,0,601,0,400H0C0,199,163,36,364,36Z",
    style: {
      fill: "#39ff14"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,2h0C593.93,2,756,164.07,756,364h0c0,199.93-162.07,362-362,362h0C194.07,726,32,563.93,32,364h0C32,164.07,194.07,2,394,2Z",
    style: {
      fill: "#c58fff",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M562.64,383.13l.77,33.3c0,118.93-61.15,192.94-180.75,192.94,0,0-167.49.16-156.49-187.19l.67-40.49L254.3,229.24l274-3.45Z",
    style: {
      fill: "#f4a995"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531,364.37l32,3.83s10.8,139.73-45.48,188.73Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,609.37c-59,0-76.32-62-76.32-120.58V184.45L537.59,245.7l2.31,248.44C542.21,554.25,481.32,601.72,408.09,609.37Z",
    style: {
      fill: "#e28a6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,200.53H492.11V510.22a100.39,100.39,0,0,1-29.69,71.19,101.67,101.67,0,0,1-71.68,29.49,107.11,107.11,0,0,1-75.49-31.06,105.67,105.67,0,0,1-31.27-75Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.18,383.13,563,274c41.63-78.1-30.06-68.91-30.06-68.91-4.62-56.27-50.44-27.92-50.44-27.92C474.57,120.71,426.59,146,426.59,146c-29.49-61.45-69.38-2.88-69.38-2.88-53.19-28.71-56.66,24.12-56.66,24.12-53.18-20.67-49.71,34.46-49.71,34.46-65.91,0-25.44,76.94-25.44,76.94V382c24.28,0,24.28-11.48,24.28-11.48V321.69a63.76,63.76,0,0,1,18.85-45A64.58,64.58,0,0,1,313.85,258H473.41a65.72,65.72,0,0,1,46.14,19,64.84,64.84,0,0,1,19.19,45.83v46.51a22,22,0,0,0,25.44,13.79Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.45,361.31c21.87,0,34.1,16.46,34.1,38.18s-12.23,37.62-34.1,37.62",
    style: {
      fill: "#ed9677",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.89,379.59A43.76,43.76,0,0,1,506,410.72a44.34,44.34,0,0,1-72.21-14.29,43.64,43.64,0,0,1-3.33-16.84c0-4.14,3.87-15.2,1.65-11.93-.11.16,85.45,1.11,85.5,1.29A43.82,43.82,0,0,1,518.89,379.59Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.64,344.84a43.1,43.1,0,0,1-.1,69.42,43.79,43.79,0,0,1-50.66.9,43.12,43.12,0,0,1-2.61-69.37",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.82,378.27a45.1,45.1,0,0,1-13,31.8,44,44,0,0,1-48.41,9.76A44.5,44.5,0,0,1,443,410.07a45.1,45.1,0,0,1-13-31.8c0-4.22,4-15.63,1.78-12.29-.11.16,85.36,1.26,85.41,1.45A46.82,46.82,0,0,1,518.82,378.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.67,368.43a26.87,26.87,0,0,1-1.66,9.31,24.52,24.52,0,0,1-4.77,7.93A22.13,22.13,0,0,1,485,391a20.41,20.41,0,0,1-17.19,0,22.18,22.18,0,0,1-7.23-5.36,24.72,24.72,0,0,1-4.78-7.93,26.63,26.63,0,0,1-1.65-9.31h44.51Zm0,0a27.48,27.48,0,0,0-.65-5.86h0a3.51,3.51,0,0,0-1-1.32,3.2,3.2,0,0,0-.39-.16l-.26-.06h-1.95c-1.08,0-2.61,0-4.45-.08l-13.47-.21h-.77L463,360.47l-4.42-.08h-.31m40.36,8-40.36-8m0,0a1.94,1.94,0,0,0-1.17-.35,2.12,2.12,0,0,0-1.19.4,2.72,2.72,0,0,0-.39.37,3.36,3.36,0,0,0-.35.49h0a2.68,2.68,0,0,0,0,1.32Z",
    style: {
      fill: "#39ff14",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36,363.13c-21.87,0-34.11,16.46-34.11,38.18s12.24,37.61,34.11,37.61",
    style: {
      fill: "#ed9677",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,422.56,385,450.89s-39.31,16.84-.77,32.92",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,525.15H423.5s10.94.91,22.89-10.95",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.46,496.83S469,502.18,462,521.33Z",
    style: {
      fill: "#ed9677"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.68,404A17.61,17.61,0,1,0,290,386.38,17.6,17.6,0,0,0,307.68,404Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,346.94a43.49,43.49,0,1,1-53.38.95",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.71,381.12a43.74,43.74,0,0,1-13,31,44.45,44.45,0,0,1-62.47,0,43.78,43.78,0,0,1-13-31c0-4.14,3.88-15.2,1.65-11.93-.11.16,85.46,1.11,85.5,1.29A44.87,44.87,0,0,1,354.71,381.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,370.17a26.62,26.62,0,0,1-1.65,9.3,24.66,24.66,0,0,1-4.78,7.94,22.32,22.32,0,0,1-7.23,5.36,20.49,20.49,0,0,1-17.19,0,22.32,22.32,0,0,1-7.23-5.36,24.66,24.66,0,0,1-4.78-7.94,26.62,26.62,0,0,1-1.65-9.3Zm0,0a27.48,27.48,0,0,0-.65-5.86h0a3.55,3.55,0,0,0-1-1.33,3.2,3.2,0,0,0-.39-.16l-.26-.06h-1.91l-4.45-.08-13.47-.2H307l-12.69-.19-4.42-.07h-.31m40.36,8-40.36-8m0,0a2,2,0,0,0-1.17-.34,2.12,2.12,0,0,0-1.19.4,2.55,2.55,0,0,0-.74.86h0a2.77,2.77,0,0,0,0,1.31Z",
    style: {
      fill: "#39ff14",
      stroke: "#000",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.64,383.13l.77,33.3c0,118.93-61.15,192.94-180.75,192.94,0,0-167.49.16-156.49-187.19l.67-40.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3,375.88c-2.87,2.71-8.67,5.52-20.4,5.6v-103l-.06-.11-.44.23.44-.23h0v-.05h0l-.06-.12-.32-.64c-.28-.56-.68-1.38-1.17-2.43-1-2.09-2.29-5.09-3.67-8.68-2.75-7.19-5.74-16.77-6.67-26.32s.19-19,5.56-26.1,15-11.82,31.38-11.82h.53v-.54h0v-2.29a58.55,58.55,0,0,1,.33-5.91A47.27,47.27,0,0,1,256.32,177c2.85-5.52,7.31-10.36,14.31-12.57s16.64-1.82,29.87,3.33l.64.24v-.67h0v-.56a14.08,14.08,0,0,1,.2-1.61,52.72,52.72,0,0,1,1.11-5.54,40.93,40.93,0,0,1,6.92-14.84A24,24,0,0,1,326,135.26c7.66-.9,17.75,1.14,31,8.28l.4.22.25-.37-.41-.29.41.29h0l.09-.12c.07-.11.18-.27.33-.47.3-.41.74-1,1.31-1.75,1.14-1.47,2.8-3.5,4.89-5.76,4.18-4.51,10-9.86,16.8-13.31s14.34-5,22.05-1.87,15.67,10.82,23,26.12l.22.47.46-.24v0h0l.1-.05.4-.19c.34-.17.86-.41,1.51-.7a54.38,54.38,0,0,1,5.5-2.07A48.42,48.42,0,0,1,451.49,141,27.73,27.73,0,0,1,470,148.9c5.52,5.48,10,14.38,12,28.43l.11.76.65-.41-.07-.12.07.12h.07l.38-.22c.33-.19.82-.47,1.44-.8a52.88,52.88,0,0,1,5.21-2.42A44.43,44.43,0,0,1,506,170.56c5.91,0,11.93,1.67,16.75,6.8s8.55,13.79,9.7,27.8v.52l.52-.06-.07-.5.07.5h.15l.58-.06c.51,0,1.25-.1,2.19-.15a66.84,66.84,0,0,1,7.49,0c6,.36,13.61,1.64,19.87,5.32s11.19,9.69,12,19.64S573,254.3,562.58,273.79l-.06.11v.1l1.15,108.7a21.62,21.62,0,0,1-14.59-2.16,21.4,21.4,0,0,1-9.84-11.31V322.84h0a65.39,65.39,0,0,0-19.33-46.18,66.26,66.26,0,0,0-46.49-19.2H313.85a65.08,65.08,0,0,0-45.67,18.87,64.18,64.18,0,0,0-19,45.37h0v48.8h0v.41a6.22,6.22,0,0,1-.31,1.2A9.58,9.58,0,0,1,246.3,375.88Z",
    style: {
      fill: "#1e1e1e",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.45,361.31c21.87,0,34.1,16.46,34.1,38.18s-12.23,37.62-34.1,37.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36,363.13c-21.87,0-34.11,16.46-34.11,38.18s12.24,37.61,34.11,37.61",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36,370.92h83.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,346.94a43.49,43.49,0,1,1-53.38.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.35,368.82l84,.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.64,344.84a43.1,43.1,0,0,1-.1,69.42,43.79,43.79,0,0,1-50.66.9,43.12,43.12,0,0,1-2.61-69.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,422.56,385,450.89s-39.31,16.84-.77,32.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,525.15H423.5s10.94.91,22.89-10.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.46,496.83S469,502.18,462,521.33",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.81,357l64.85.17,6.21,6.68,1.75,4.21-82-.2.81-2.57Z",
    style: {
      fill: "#d17559"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5,370l-63.84-.08.37-1.23,7.12-9,55.79-1.4Z",
    style: {
      fill: "#d17559"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.64924171.svg";
export { ForwardRef as ReactComponent };